import { all, fork } from 'redux-saga/effects';
import list from './list';

export default function* events() {
  yield all([fork(list)]);
}
